import { Query } from '../../design-system/types';
import { filters } from '../../domain/filters';

// We remove the filter 'arrivalDateTo' from the list because
// 'arrivalDateFrom' & 'arrivalDateTo' are the same
// filter (arrival date) and should not be counted as two filters
// Same for request date
// Same for min/max budget
const limitRangeFiltersToOneKey = () =>
    filters.filter((x) => x !== 'arrivalDateTo' && x !== 'requestDateTo' && x !== 'minBudget');

export function countActiveFilters(query: Query): number {
    const filtersToCount = limitRangeFiltersToOneKey();
    return Object.keys(query)
        .filter((key) => query[key] !== 'all')
        .filter((key) => filtersToCount.includes(key)).length;
}
